import React from 'react';

interface IRightIconProps
  extends React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  children: React.ReactNode;
}

export const RightIcon: React.FC<IRightIconProps> = ({
  children,
  ...props
}) => {
  return (
    <button
      type="button"
      className={`right-icon tw-lf-input-right-icon peer-disabled:tw-cursor-not-allowed`}
      {...props}
    >
      {children}
    </button>
  );
};
